import * as React from "react";
import * as ReactDOM from "react-dom";
import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { createRoot } from "react-dom/client";
import { PLYLoader } from "three-stdlib";

import "./styles.css";
import {
  AdditiveBlending,
  Box3,
  BufferGeometry,
  BufferGeometryUtils,
  Color,
  Group,
  Matrix4,
  Mesh,
  MeshStandardMaterial,
  NoBlending,
  NormalBlending,
  Object3D,
  Points,
  PointsMaterial,
  Quaternion,
  Vector3,
} from "three";

import { useLoader } from "@react-three/fiber";
import { GLTF, GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

import { Stats, OrbitControls } from "@react-three/drei";
import Revealable from "./reveal";

function OMMScene(){
  const scene = new Revealable();
  const ply = useLoader(PLYLoader, "./assets/PLY/filtered/omm_filtered_500k.ply") as BufferGeometry;

  const mat = new PointsMaterial({
        color: 0xffffff,
        size: 0.01,
        blending: AdditiveBlending,
        transparent: true,
        opacity: 0.8,
        depthWrite: true,
        depthTest: true,
        sizeAttenuation: true,
        vertexColors: false
  });
  const mesh = new Points(ply, mat);
  scene.add(mesh);
  scene.setColor(new Color().setHSL(Math.random(), 1, 0.1));


// const points = new Revealable();
// points.add(ToPoints(headset));

const { camera, mouse, size } = useThree();
const camDefaultPos = camera.position;

const objectRotations = [
  new Quaternion().setFromAxisAngle(new Vector3(-0.25, 0.5, 0), Math.PI / 4),
  new Quaternion().setFromAxisAngle(new Vector3(0, 1, 0), Math.PI / 2),
  new Quaternion().setFromAxisAngle(new Vector3(-1, 0, 0), Math.PI / 2),
  new Quaternion().setFromAxisAngle(new Vector3(0, 1, 0), (Math.PI / 2) * 3),
  new Quaternion().setFromAxisAngle(new Vector3(0, 1, 0), 0),
];

let objectRotationsIndex = 0;
let nSeconds = 10;
let timeVal = 0;

scene.setVisible(true);
// points.setVisible(true);

useFrame((state, delta) => {
  timeVal += delta;

  if (timeVal >= 1 && timeVal <= 3) scene.setVisible(true);
  else if (timeVal >= 8) scene.setVisible(false);

  if (timeVal >= nSeconds) {
    objectRotationsIndex =
      (objectRotationsIndex + 1) % objectRotations.length;
    timeVal = 0;
    scene.setColor(new Color().setHSL(Math.random(), 1, 0.1));
    camera.position.set(camDefaultPos.x, camDefaultPos.y + (Math.random()-0.5), camDefaultPos.z);
  }
});

return (
  <React.Suspense>
    <primitive object={scene} position={[0, 0, 0]} />
    {/* <primitive object={points} position={[0, 0, 0]} /> */}
  </React.Suspense>
);
}

function Rig() {
// const { camera, mouse, size } = useThree();
// const moveCoeff = 50;

// const mouseVec = new Vector3();
// const cameraBase = new Object3D();
// const root = new Object3D();

// root.add(cameraBase);
// cameraBase.add(camera);
// cameraBase.rotateOnWorldAxis(new Vector3(0, 1, 0), Math.PI / 2);
return useFrame((state, delta) => {
  // cameraBase.position.lerp(
  //   mouseVec.set(mouse.x / moveCoeff, -mouse.y / moveCoeff, 0),
  //   0.05
  // );
  // camera.lookAt(camera.position.x, camera.position.y, 0);
});
}

function App() {
const headset = React.useRef<Object3D>(null);

return (
  <Canvas
    // camera={{
    //   position: [0, 0, -0.4],
    //   near: 0.0001,
    //   far: 500,
    //   fov: 1,
    // }}
    
    camera={{
      position: [-2, 0.5, 1.7],
      near: 0.0001,
      far: 50000,
      fov: 60,
    }}
    
    // shadows
  >
    <color attach="background" args={["black"]} />
    {/* <directionalLight position={[3.3, 1.0, -4.4]} /> */}
    {/* <ambientLight intensity={1.2}></ambientLight> */}
    {/* <Headset ref={headset} /> */}

    <OMMScene />
    <OrbitControls target={[-3, 0.5, 0]} autoRotate autoRotateSpeed={1} enablePan={false} enableRotate={false} enableZoom={false} />
    <Rig/>
    {/* <Stats /> */}
  </Canvas>
);
}

createRoot(document.getElementById("ThreeScene")).render(<App></App>);
// createRoot(document.getElementById("root")).render(<App></App>);
